<template>
  <div v-if="(showErrorNotice || showWarningNotice) && isValidPage">
    <b-alert v-if="showErrorNotice && isValidPage" class="mt-2" show variant="danger">
      {{ $t('billing.expired') }}
      <b-button style="padding:0;margin:0;" variant="link" @click="$router.push({ name: 'user-subscription' })"><strong>
        {{ $t('billing.renew') }}</strong></b-button>
    </b-alert>
    <b-alert v-if="showWarningNotice && isValidPage" class="mt-2" show variant="warning">

      {{ $t('billing.' + ((difference === 1) ? 'willExpireSingle' : 'willExpirePlural'), {days: difference}) }}
      <b-button style="padding:0;margin:0;" variant="link" @click="$router.push({ name: 'user-subscription' })"><strong>
        {{ $t('billing.renew') }}</strong></b-button>
    </b-alert>
  </div>
</template>

<script>

import {mapState} from "vuex";
import moment from "moment";

export default {

  computed: {
    ...mapState({
      user: state => state.auth.currentUser
    }),
    isValidPage() {
      return this.$route.name !== 'pay-transaction';
    }
  },
  data() {
    return {
      showWarningNotice: false,
      showErrorNotice: false,
      difference: null
    }
  },
  created() {
    this.calculateDaysUntilSubscriptionEnds();
  },
  methods: {
    calculateDaysUntilSubscriptionEnds() {

      if (!this.user || !this.user.subscriptionDue) return;

      let dateFrom = moment(new Date());
      let dateTo = moment(new Date(this.user.subscriptionDue.substr(0, 10)));

      let difference = dateTo.diff(dateFrom, 'days');

      this.difference = difference;

      if (difference > 0 && difference < 7) {
        this.showWarningNotice = true;
      }

      if (difference <= 0) {
        this.showErrorNotice = true;
      }

      if (difference > 7) {
        this.showWarningNotice = false;
        this.showErrorNotice = false;
      }

    },
  }

}
</script>
